// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Json_encode from "@glennsl/bs-json/src/Json_encode.bs.js";

function currency(c) {
  switch (c) {
    case /* USD */0 :
        return "USD";
    case /* GBP */1 :
        return "GBP";
    case /* EUR */2 :
        return "EUR";
    case /* ZAR */3 :
        return "ZAR";
    case /* KYD */4 :
        return "KYD";
    case /* CHF */5 :
        return "CHF";
    
  }
}

function contract(contractRecord) {
  switch (contractRecord.tag | 0) {
    case /* ZCB */0 :
        return Json_encode.object_(/* :: */[
                    /* tuple */[
                      "tag",
                      "ZCB"
                    ],
                    /* :: */[
                      /* tuple */[
                        "time",
                        contractRecord[/* time */0]
                      ],
                      /* :: */[
                        /* tuple */[
                          "value",
                          contractRecord[/* value */1]
                        ],
                        /* :: */[
                          /* tuple */[
                            "currency",
                            currency(contractRecord[/* currency */2])
                          ],
                          /* [] */0
                        ]
                      ]
                    ]
                  ]);
    case /* European */1 :
        return Json_encode.object_(/* :: */[
                    /* tuple */[
                      "tag",
                      "European"
                    ],
                    /* :: */[
                      /* tuple */[
                        "time",
                        contractRecord[/* time */0]
                      ],
                      /* :: */[
                        /* tuple */[
                          "contract",
                          contract(contractRecord[/* contract */1])
                        ],
                        /* [] */0
                      ]
                    ]
                  ]);
    case /* American */2 :
        return Json_encode.object_(/* :: */[
                    /* tuple */[
                      "tag",
                      "American"
                    ],
                    /* :: */[
                      /* tuple */[
                        "timeAfter",
                        contractRecord[/* timeAfter */0]
                      ],
                      /* :: */[
                        /* tuple */[
                          "timeBefore",
                          contractRecord[/* timeBefore */1]
                        ],
                        /* :: */[
                          /* tuple */[
                            "contract",
                            contract(contractRecord[/* contract */2])
                          ],
                          /* [] */0
                        ]
                      ]
                    ]
                  ]);
    case /* GiveContract */3 :
        return Json_encode.object_(/* :: */[
                    /* tuple */[
                      "tag",
                      "GiveContract"
                    ],
                    /* :: */[
                      /* tuple */[
                        "contract",
                        contract(contractRecord[/* contract */0])
                      ],
                      /* [] */0
                    ]
                  ]);
    case /* AndContracts */4 :
        return Json_encode.object_(/* :: */[
                    /* tuple */[
                      "tag",
                      "AndContracts"
                    ],
                    /* :: */[
                      /* tuple */[
                        "contracts",
                        Json_encode.list(contract, contractRecord[/* contracts */0])
                      ],
                      /* [] */0
                    ]
                  ]);
    case /* OrContracts */5 :
        return Json_encode.object_(/* :: */[
                    /* tuple */[
                      "tag",
                      "OrContracts"
                    ],
                    /* :: */[
                      /* tuple */[
                        "contracts",
                        Json_encode.list(contract, contractRecord[/* contracts */0])
                      ],
                      /* [] */0
                    ]
                  ]);
    
  }
}

function contracts(cs) {
  return Json_encode.list(contract, cs);
}

var Encode = {
  currency: currency,
  contract: contract,
  contracts: contracts
};

export {
  Encode ,
  
}
/* No side effect */
